import { getApiErrorMessage, notifyApiError } from 'utils/apiError';

const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL || '').replace(/\/$/, '');

export const DEFAULT_ACCESS = {
  view: true,
  add: true,
  modify: true,
  delete: true,
  approve: true
};

export const DENIED_ACCESS = {
  view: false,
  add: false,
  modify: false,
  delete: false,
  approve: false
};

const PUBLIC_PREFIXES = ['/auth', '/uploads', '/api-docs', '/swagger', '/meetings'];
const PUBLIC_PATHS = ['/', '/favicon.ico'];
const CACHE_TTL_MS = 30000;

let menuCache = null;
let menuCacheAt = 0;
let menuRequest = null;

const API_MENU_PATH_ALIASES = {
  '/employees/options/attendance-list': '/attendance/list',
  '/employees/options/attendance-reports': '/attendance/reports',
  '/employees/options/work-records': '/attendance/work-records',
  '/employees/options/course-assignments': '/courses/assignments',
  '/employees/options/payroll': '/payroll/employee-payroll',
  '/employees/options/asset-assignments': '/assets/assignments',
  '/employees/options/performance-reviews': '/performance/reviews',
  '/employees/options/performance-goals': '/performance/goals',
  '/employees/options/performance-feedback': '/performance/feedback',
  '/employees/options/performance-appraisals': '/performance/appraisals',
  '/employees/options/users': '/user',
  '/employees/options/permissions': '/role-mapping',
  '/employees/options/approval-workflows': '/approval-workflows',
  '/attendance/approval-requests': '/attendance/approval',
  '/attendance/current-policy': '/attendance',
  '/attendance/current-status': '/attendance/my-attendance',
  '/attendance/check-in': '/attendance/my-attendance',
  '/attendance/check-out': '/attendance/my-attendance',
  '/attendance/regularization/employee-options': '/attendance/regularization',
  '/attendance/regularization/': '/attendance/approval',
  '/attendance/missing-punch/employee-options': '/attendance/missing-punch',
  '/attendance/missing-punch/': '/attendance/approval',
  '/attendance/work-from-home/employee-options': '/attendance/work-from-home',
  '/attendance/work-from-home/': '/attendance/approval',
  '/attendance/monthly-calendar': '/attendance/list',
  '/attendance/daily': '/attendance/list',
  '/attendance/manual': '/attendance/list',
  '/attendance/shifts': '/attendance/shift-management',
  '/attendance/weekly-off': '/attendance/weekly-off',
  '/attendance/work-records': '/attendance/work-records',
  '/attendance/my-attendance': '/attendance/my-attendance',
  '/attendance/regularization': '/attendance/regularization',
  '/attendance/missing-punch': '/attendance/missing-punch',
  '/attendance/work-from-home': '/attendance/work-from-home',
  '/attendance/bulk-upload': '/attendance/bulk-upload',
  '/attendance/overtime': '/attendance/overtime',
  '/attendance/policy': '/attendance/policy',
  '/attendance/settings': '/attendance/settings',
  '/attendance/dashboard': '/attendance/dashboard',
  '/attendance/list': '/attendance/list',
  '/employees': '/employees',
  '/courses/dashboard/hr': '/courses/master',
  '/courses/dashboard/employee/': '/courses/my-courses',
  '/courses/reports': '/courses/master',
  '/courses/training-sessions': '/courses/master',
  '/courses/certificates/': '/courses/my-courses',
  '/courses/assignments/bulk': '/courses/assignments',
  '/courses/employee/': '/courses/my-courses',
  '/courses/certificate-approvals': '/courses/certificate-approvals',
  '/courses/assignments': '/courses/assignments',
  '/courses': '/courses/master',
  '/attendance': '/attendance',
  '/leave/pending-approvals': '/leave/approval',
  '/leave/policies': '/leave/policy',
  '/leave/holidays': '/leave/holiday-calendar',
  '/leave/events': '/leave/holiday-calendar',
  '/leave/recurrence-types': '/leave/holiday-calendar',
  '/leave/recurrence-master': '/leave/recurrence-master',
  '/leave/cancellations': '/leave/cancellation',
  '/leave/dashboard': '/leave/dashboard',
  '/leave/applications': '/leave/applications',
  '/leave/approval': '/leave/approval',
  '/leave/types': '/leave/types',
  '/leave/balance': '/leave/balance',
  '/leave/comp-off': '/leave/comp-off',
  '/leave/encashment': '/leave/encashment',
  '/leave/reports': '/leave/reports',
  '/leave/notifications': '/leave/notifications',
  '/leave': '/leave',
  '/payroll/runs': '/payroll/run',
  '/payroll/run-employees': '/payroll/run',
  '/payroll/adjustments': '/payroll/run',
  '/payroll/payout-batches': '/payroll/run',
  '/payroll/tax-policies': '/payroll/settings',
  '/payroll/tax-declarations': '/payroll/settings',
  '/payroll/runs/calculate': '/payroll/run',
  '/payroll/salary-structures': '/payroll/salary-structure',
  '/payroll/find': '/payroll/employee-payroll',
  '/payroll/client-staff': '/payroll/employee-payroll',
  '/payroll/payslips': '/payroll/payslips',
  '/payroll/reports': '/payroll/reports',
  '/payroll/settings': '/payroll/settings',
  '/payroll/dashboard': '/payroll/dashboard',
  '/payroll': '/payroll/employee-payroll',
  '/expenses/claims': '/payroll/employee-payroll',
  '/expenses/company-expenses': '/payroll/employee-payroll',
  '/expenses/approvals': '/payroll/run',
  '/expenses/categories': '/payroll/settings',
  '/expenses': '/payroll/employee-payroll',
  '/projects/employee-options/clients': '/projects/clients',
  '/projects/employee-options/tasks': '/projects/tasks',
  '/projects/employee-options/timesheets': '/projects/timesheets',
  '/projects/employee-options/reports': '/projects/reports',
  '/projects/employee-options/list': '/projects/list',
  '/projects/client-options': '/projects/list',
  '/projects/clients': '/projects/clients',
  '/projects/tasks': '/projects/tasks',
  '/projects/milestones': '/projects/milestones',
  '/projects/reviews': '/projects/reviews',
  '/projects/resources': '/projects/resources',
  '/projects/risks': '/projects/risks',
  '/projects/details': '/projects/list',
  '/projects/timesheets': '/projects/timesheets',
  '/projects/reports': '/projects/reports',
  '/projects/analytics': '/projects/analytics',
  '/projects/settings': '/projects/settings',
  '/projects/dashboard': '/projects/dashboard',
  '/projects': '/projects/list',
  '/assets/assignments': '/assets/assignments',
  '/assets/requests': '/assets/requests',
  '/assets/assign': '/assets/assignments',
  '/assets/maintenance': '/assets/maintenance',
  '/assets/reports': '/assets/reports',
  '/assets/settings': '/assets/settings',
  '/assets/dashboard': '/assets/dashboard',
  '/assets': '/assets/list',
  '/performance/reviews': '/performance/reviews',
  '/performance/goals': '/performance/goals',
  '/performance/feedback': '/performance/feedback',
  '/performance/appraisals': '/performance/appraisals',
  '/performance/reports': '/performance/reports',
  '/performance/settings': '/performance/settings',
  '/performance/dashboard': '/performance/dashboard',
  '/performance': '/performance',
  '/recruitment/jobs': '/recruitment/jobs',
  '/recruitment/candidates': '/recruitment/candidates',
  '/recruitment/interviews': '/recruitment/interviews',
  '/recruitment/reports': '/recruitment/reports',
  '/recruitment/settings': '/recruitment/settings',
  '/recruitment/dashboard': '/recruitment/dashboard',
  '/recruitment': '/recruitment',
  '/enterprise/notifications': '/attendance',
  '/enterprise/reports': '/payroll/reports',
  '/enterprise/audit': '/role-mapping',
  '/enterprise/bootstrap': '/role-mapping',
  '/company': '/system-config/company',
  '/company-branch': '/system-config/company-branch',
  '/department': '/system-config/department',
  '/designation': '/system-config/designation',
  '/state': '/state',
  '/city': '/city',
  '/pincode': '/pincode',
  '/user': '/user',
  '/role': '/role',
  '/menu': '/menu',
  '/role-mapping': '/role-mapping'
};

const ROUTE_MENU_PATH_ALIASES = {
  '/dashboard/default': '/dashboard/default',
  '/dashboard': '/dashboard/default',
  '/employees/employee': '/employees',
  '/employees': '/employees',
  '/employee': '/employees',
  '/courses/master': '/courses/master',
  '/courses/dashboard': '/courses/master',
  '/courses/reports': '/courses/master',
  '/courses/training-sessions': '/courses/master',
  '/courses/assignments': '/courses/assignments',
  '/courses/certificate-approvals': '/courses/certificate-approvals',
  '/courses/my-courses': '/courses/my-courses',
  '/courses': '/courses',
  '/attendance/dashboard': '/attendance/dashboard',
  '/attendance/list': '/attendance/list',
  '/attendance/daily': '/attendance/list',
  '/attendance/monthly': '/attendance/list',
  '/attendance/work-records': '/attendance/work-records',
  '/attendance/my-attendance': '/attendance/my-attendance',
  '/attendance/regularization': '/attendance/regularization',
  '/attendance/missing-punch': '/attendance/missing-punch',
  '/attendance/work-from-home': '/attendance/work-from-home',
  '/attendance/bulk-upload': '/attendance/bulk-upload',
  '/attendance/shift-management': '/attendance/shift-management',
  '/attendance/policy': '/attendance/policy',
  '/attendance/weekly-off': '/attendance/weekly-off',
  '/attendance/overtime': '/attendance/overtime',
  '/attendance/approval': '/attendance/approval',
  '/attendance/reports': '/attendance/reports',
  '/attendance/settings': '/attendance/settings',
  '/attendance': '/attendance',
  '/leave/dashboard': '/leave/dashboard',
  '/leave/applications': '/leave/applications',
  '/leave/approval': '/leave/approval',
  '/leave/types': '/leave/types',
  '/leave/balance': '/leave/balance',
  '/leave/policy': '/leave/policy',
  '/leave/holiday-calendar': '/leave/holiday-calendar',
  '/leave/recurrence-master': '/leave/recurrence-master',
  '/leave/comp-off': '/leave/comp-off',
  '/leave/encashment': '/leave/encashment',
  '/leave/cancellation': '/leave/cancellation',
  '/leave/reports': '/leave/reports',
  '/leave/notifications': '/leave/notifications',
  '/leave': '/leave',
  '/payroll/dashboard': '/payroll/dashboard',
  '/payroll/client-staff': '/payroll/employee-payroll',
  '/payroll/run': '/payroll/run',
  '/payroll/salary-structure': '/payroll/salary-structure',
  '/payroll/employee-payroll': '/payroll/employee-payroll',
  '/payroll/payslips': '/payroll/payslips',
  '/payroll/reports': '/payroll/reports',
  '/payroll/settings': '/payroll/settings',
  '/payroll': '/payroll',
  '/expenses/claims': '/payroll/employee-payroll',
  '/expenses/approvals': '/payroll/run',
  '/expenses/company-expenses': '/payroll/employee-payroll',
  '/expenses': '/payroll/employee-payroll',
  '/projects/dashboard': '/projects/dashboard',
  '/projects/list': '/projects/list',
  '/projects/clients': '/projects/clients',
  '/projects/tasks': '/projects/tasks',
  '/projects/reviews': '/projects/reviews',
  '/projects/timesheets': '/projects/timesheets',
  '/projects/reports': '/projects/reports',
  '/projects/settings': '/projects/settings',
  '/projects': '/projects',
  '/assets/dashboard': '/assets/dashboard',
  '/assets/list': '/assets/list',
  '/assets/assignments': '/assets/assignments',
  '/assets/requests': '/assets/requests',
  '/assets/maintenance': '/assets/maintenance',
  '/assets/reports': '/assets/reports',
  '/assets/settings': '/assets/settings',
  '/assets': '/assets',
  '/performance/dashboard': '/performance/dashboard',
  '/performance/reviews': '/performance/reviews',
  '/performance/goals': '/performance/goals',
  '/performance/feedback': '/performance/feedback',
  '/performance/appraisals': '/performance/appraisals',
  '/performance/reports': '/performance/reports',
  '/performance/settings': '/performance/settings',
  '/performance': '/performance',
  '/recruitment/dashboard': '/recruitment/dashboard',
  '/recruitment/jobs': '/recruitment/jobs',
  '/recruitment/candidates': '/recruitment/candidates',
  '/recruitment/interviews': '/recruitment/interviews',
  '/recruitment/reports': '/recruitment/reports',
  '/recruitment/settings': '/recruitment/settings',
  '/recruitment': '/recruitment',
  '/enterprise/reports': '/payroll/reports',
  '/enterprise/audit': '/role-mapping',
  '/enterprise': '/payroll/reports',
  '/company': '/system-config/company',
  '/company-branch': '/system-config/company-branch',
  '/department': '/system-config/department',
  '/designation': '/system-config/designation',
  '/system-config/company': '/system-config/company',
  '/system-config/company-branch': '/system-config/company-branch',
  '/system-config/department': '/system-config/department',
  '/system-config/designation': '/system-config/designation',
  '/system-config': '/system-config/company',
  '/user-management/users': '/user',
  '/user-management/roles': '/role',
  '/user-management/permissions': '/role-mapping',
  '/user-management/approval-workflows': '/approval-workflows',
  '/user-management': '/user-management'
};

export function clearMenuAccessCache() {
  menuCache = null;
  menuCacheAt = 0;
  menuRequest = null;
}

export async function fetchLoginUserMenu({ force = false } = {}) {
  if (!localStorage.getItem('authToken')) {
    clearMenuAccessCache();
    return [];
  }
  if (!force && menuCache && Date.now() - menuCacheAt < CACHE_TTL_MS) return menuCache;
  if (!force && menuRequest) return menuRequest;

  menuRequest = rawApiRequest('/menu/login-user-menu')
    .then((response) => {
      menuCache = response?.data ?? response ?? [];
      menuCacheAt = Date.now();
      return menuCache;
    })
    .finally(() => {
      menuRequest = null;
    });

  return menuRequest;
}

export async function fetchMenuAccess(path) {
  const menus = await fetchLoginUserMenu();
  return getMenuAccess(menus, path);
}

export function getMenuAccess(items = [], path) {
  const normalizedPath = normalizePath(path);
  if (!normalizedPath) return DEFAULT_ACCESS;

  let menu = findMenuByPath(items, normalizedPath);
  if (!menu) {
    const parentPath = normalizedPath.substring(0, normalizedPath.lastIndexOf('/'));
    if (parentPath && parentPath !== '/') {
      menu = findMenuByPath(items, parentPath);
    }
  }

  if (!menu) return DENIED_ACCESS;

  return {
    view: !!menu?.actions?.view,
    add: !!menu?.actions?.add,
    modify: !!menu?.actions?.modify,
    delete: !!menu?.actions?.delete,
    approve: !!menu?.actions?.approve,
    dataScope: menu?.dataScope || 'Self'
  };
}

export function isPublicPath(path) {
  const normalizedPath = normalizePath(path);
  return PUBLIC_PATHS.includes(normalizedPath) || PUBLIC_PREFIXES.some((prefix) => normalizedPath.startsWith(prefix));
}

export function routeToMenuPath(pathname) {
  const normalizedPath = normalizePath(pathname);
  // The meeting list is a permissioned menu; rooms retain their guest flow.
  if (['/meetings', '/meetings/list'].includes(normalizedPath.toLowerCase())) return '/meetings';
  if (isPublicPath(normalizedPath)) return null;
  if (/^\/projects\/[^/]+\/tasks(?:\/|$)/.test(normalizedPath.toLowerCase())) return '/projects/tasks';
  return findLongestAlias(normalizedPath, ROUTE_MENU_PATH_ALIASES) || null;
}

export function apiPathToMenuPath(path) {
  const normalizedPath = normalizePath(path);
  if (isPublicPath(normalizedPath)) return null;
  return findLongestAlias(normalizedPath, API_MENU_PATH_ALIASES);
}

export function permissionActionForRequest(method = 'GET', path = '/') {
  const normalizedMethod = method.toUpperCase();
  const normalizedPath = normalizePath(path).toLowerCase();

  if (normalizedMethod === 'GET') return 'view';
  if (normalizedPath.includes('/notifications/') && normalizedPath.endsWith('/read')) return 'view';
  if (['/attendance/check-in', '/attendance/check-out', '/attendance/regularization', '/attendance/missing-punch', '/attendance/work-from-home'].includes(normalizedPath)) return 'view';
  if (normalizedPath.startsWith('/courses/employee/') && normalizedPath.endsWith('/certificate')) return 'view';
  if (normalizedPath.startsWith('/courses/employee/') && normalizedPath.includes('/assignments/') && normalizedPath.endsWith('/start')) return 'view';
  if (normalizedPath.startsWith('/courses/employee/') && normalizedPath.endsWith('/external-certifications')) return 'view';
  if (normalizedMethod === 'POST' && normalizedPath.endsWith('/find')) return 'view';
  if (normalizedMethod === 'POST' && normalizedPath === '/leave/balance') return 'modify';
  if (normalizedPath.includes('/approve') || normalizedPath.includes('/reject')) return 'approve';
  if (normalizedMethod === 'POST') return 'add';
  if (normalizedMethod === 'PUT' || normalizedMethod === 'PATCH') return 'modify';
  if (normalizedMethod === 'DELETE') return 'delete';
  return 'view';
}

export async function ensureRequestAccess(path, options = {}) {
  const method = options.method || 'GET';
  const action = permissionActionForRequest(method, path);
  if (action === 'view') return;

  const menuPath = apiPathToMenuPath(path);
  if (!menuPath) return;

  const access = await fetchMenuAccess(menuPath);
  if (!access[action]) {
    throw new Error(`You do not have ${action} access for ${menuPath}`);
  }
}

export function inferPermissionAction(label) {
  const text = getText(label).toLowerCase();
  if (!text) return null;

  if (/\b(delete|remove|discard)\b/.test(text)) return 'delete';
  if (/\b(approve|reject)\b/.test(text)) return 'approve';
  if (/\b(edit|update)\b/.test(text)) return 'modify';
  if (/\b(add|create|new)\b/.test(text)) return 'add';
  if (/\b(save|submit)\b/.test(text)) return 'write';
  return null;
}

export function canUseAction(access, action) {
  if (!action) return true;
  if (action === 'write') return !!(access?.add || access?.modify);
  return !!access?.[action];
}

export function normalizePath(path) {
  const value = String(path || '').trim();
  if (!value) return '';
  return value.startsWith('/') ? value : `/${value}`;
}

function findLongestAlias(path, aliases) {
  const normalizedPath = normalizePath(path).toLowerCase();
  const match = Object.keys(aliases)
    .sort((a, b) => b.length - a.length)
    .find((alias) => {
      const normalizedAlias = normalizePath(alias).toLowerCase();
      return normalizedAlias.endsWith('/')
        ? normalizedPath.startsWith(normalizedAlias)
        : normalizedPath === normalizedAlias || normalizedPath.startsWith(`${normalizedAlias}/`);
    });
  return match ? aliases[match] : null;
}

function findMenuByPath(items = [], path) {
  for (const item of Array.isArray(items) ? items : []) {
    const routerLink = Array.isArray(item.routerLink) ? item.routerLink[0] : item.routerLink;
    if (normalizePath(routerLink) === path) return item;
    const child = findMenuByPath(item.items, path);
    if (child) return child;
  }
  return null;
}

function getText(value) {
  if (value === null || value === undefined || typeof value === 'boolean') return '';
  if (typeof value === 'string' || typeof value === 'number') return String(value);
  if (Array.isArray(value)) return value.map(getText).join(' ');
  if (typeof value === 'object' && value.props) return getText(value.props.children);
  return '';
}

function buildUrl(path) {
  const normalizedPath = normalizePath(path);
  return API_BASE_URL
    ? `${API_BASE_URL}${normalizedPath}`
    : new URL(normalizedPath, window.location.origin).toString();
}

async function rawApiRequest(path) {
  const token = localStorage.getItem('authToken');
  const response = await fetch(buildUrl(path), {
    headers: {
      Accept: 'application/json',
      'X-User-Id': localStorage.getItem('userId') || 'ui-user',
      'X-User-Role': localStorage.getItem('userRole') || 'Employee',
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    }
  });

  const contentType = response.headers.get('content-type') || '';
  const data = contentType.includes('application/json') ? await response.json() : await response.text();

  if (!response.ok) {
    const message = getApiErrorMessage(data, `Request failed with status ${response.status}`);
    const error = new Error(message);
    error.status = response.status;
    error.data = data;
    notifyApiError(error);
    throw error;
  }

  return data;
}
